import React from "react";
import styled from "styled-components";
import getConfig from "next/config";
import { useRouter } from "next/router";

const { publicRuntimeConfig } = getConfig();

const StyleOuterContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const StyledInnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 1444px;
  border-top: 1px solid #000000;
  width: 100%;
  padding-top: 20px;
  padding-bottom: 80px;
  padding-left: 16px;
  padding-right: 16px;

  .section-title {
    margin-bottom: 8px;
    font-family: NoticiaText;
    font-weight: 700;
    font-size: 38px;
    line-height: 55px;
    text-align: center;
    color: #07437a;
    text-decoration: underline;
  }
  .section-subtitle {
    font-size: 24px;
    font-family: NoticiaText;
    margin-bottom: 64px;
    font-weight: 400;
    text-align: center;
    color: #4B4B4B;
  }
  .section-content-container {
    display: flex;
    justify-content: center;
    gap: 80px;

    .section-card-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      max-width: 442px;

      .section-card-image {
        margin-bottom: 24px;

        img {
          width: 100%;
          object-fit: cover;
        }
      }

      .section-card-title {
        margin-bottom: 16px;
        font-family: "Aeonik";
        font-weight: 700;
        font-size: 28px;
        line-height: 32px;
        text-align: center;
        color: #07437a;
      }

      .section-card-text {
        font-family: "Aeonik";
        font-weight: 400;
        font-size: 18px;
        line-height: 20px;
        text-align: center;
        color: #07437a;
      }
    }
  }

  @media ${({ theme }) => theme.devices.tablet} {
    padding-top: 32px;
    padding-bottom: 32px;

    .section-title {
      margin-bottom: 24px;
      font-size: 38px;
      line-height: 42px;
    }

    .section-content-container {
      flex-direction: column;
      gap: 32px;

      .section-card-container {
        min-height: unset;

        .section-card-image {
          margin-bottom: 16px;
        }

        .section-card-title {
          margin-bottom: 8px;
          font-size: 24px;
          line-height: 32px;
        }

        .section-card-text {
          font-size: 16px;
          line-height: 20px;
        }
      }
    }
  }
`;
const StyledButton = styled.div`
  border: 1px solid #000000;
  background: #ffffff;
  color: #000000;
  font-family: NoticiaText;
  font-size: 21px;
  font-weight: 700;
  line-height: 28.66px;
  width: 80%;
  border-radius: 5px;
  cursor: pointer;
` ;
const StyledCard = styled.div`
  background: linear-gradient(360deg, #094B88 69.5%, #094B88 82.5%, #1084EE 100%);
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: NoticiaText;
  text-align: center;
  padding: 20px;
  padding-bottom: 40px;
  flex: 1 1 0;
  color: #ffffff;
  justify-content: space-between;
  .title {
    margin-top: 16px;
    font-weight: 700;
    font-size: 21px;
    line-height: 32px;
  }
  .details {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
  }
  .divider {
    height: 1px;
    width: 100%;
    margin-top: 8px;
    margin-bottom: 40px;
    border: 1px solid #ffffff;
  }
  .containerButton {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;
const OurServicesSection = ({onGoToContactUs}) => {
  const router = useRouter();
  const handleBasicClick = () => {
    router.push("https://turbotax.intuit.com/personal-taxes/online/live/full-service/business-taxes/");
  };
  const items = [
    {
      title: 'Tax Filing',
      image: `${publicRuntimeConfig.basePath}/images/V2/V2-landing-2/services1.png`,
      details: 'Avoid Costly Mistakes and File Correctly',
      buttonText: 'START NOW',
      handle: handleBasicClick,
    },
    {
      title: 'Accounting',
      image: `${publicRuntimeConfig.basePath}/images/V2/V2-landing-2/services2.png`,
      details: 'Allow Our Accountants to help with your accounting',
      buttonText: 'Contact Us',
      handle: onGoToContactUs,
    },
    {
      title: 'Bookkeeping',
      image: `${publicRuntimeConfig.basePath}/images/V2/V2-landing-2/services3.png`,
      details: 'Keep your books done right',
      buttonText: 'Contact Us',
      handle: onGoToContactUs,
    }
  ];

  return (
    <StyleOuterContainer>
      <StyledInnerContainer>
        <div className="section-title">Our Services</div>
        <div className="section-subtitle">Comprehensive services to help run your business</div>
        <div className="section-content-container">
          {items?.map(({ title, details, image, buttonText, handle }, j) => (
            <StyledCard key={'card' + j}>
              <picture>
                <source
                  srcSet={image}
                  type="image/png"
                />
                <img src={image} alt="" />
              </picture>
              <div className="title">{title}</div>
              <div className="details">{details}</div>
              <div className="containerButton">
                <div className="divider" />
                <StyledButton onClick={handle}>{buttonText}</StyledButton>
              </div>
            </StyledCard>))}
        </div>
      </StyledInnerContainer>
    </StyleOuterContainer>
  );
};

export default OurServicesSection;
